import React from 'react';
import styled from 'styled-components';
import { Cell, Row } from '../../../components/List';
import { Button } from '../../../components/Buttons';
import { EditSquare, Times, TimesSquare } from '../../../components/Icon';
import { lbl } from '../../../utils/intl';
import { VBox, HBox } from '../../../components/Box';
import { BtwOrMarge, INVOICE_SUBJECT_TYPES } from '../constants';
import { formatCurrency } from '../../../utils/string';
import { AlignLeft } from 'react-feather';
// import { lbl } from '../../utils/intl';
import { OnMouseOverNotification } from './../../Vehicles/components/OnMouseOverNotification';
import styles from './InvoiceSubjectListItem.module.css';

const sanitizeDescription = string => {
  return string.length > 50 ? string.slice(0, 29) + '...' : string;
};

const labelString = subject => {
  const description = subject?.description ?? 'Click for details...';

  return sanitizeDescription(description);
};

export function InvoiceSubjectListItem(props) {
  const onClick = () => {
    props.onClick(props.subject.id);
  };
  const onDelete = () => {
    props.onDelete(props.subject.id);
  };

  const renderIncomingSubjectItem = () => {
    return (
      <Row key={props.subject.id}>
        <Cell onClick={onClick}>{labelString(props.subject)}</Cell>
        <Cell>{props?.subject?.price}</Cell>
        <Cell>
          <Button onClick={onDelete}>
            <Times />
          </Button>
        </Cell>
      </Row>
    );
  };

  const renderSubjectV2design = () => {
    const isProductSubject = props.subject.type == INVOICE_SUBJECT_TYPES.PRODUCT;

    return (
      <Row key={props.subject.id}>
        <HBox
          vCenter
          style={{ borderTop: '1px solid black', width: '100%', flexDirection: 'row', alignItems: 'flex-start' }}
        >
          {isProductSubject && (
            <VBox left>
              <strong style={{ width: '100%', paddingTop: '20px' }}>
                {props.subject?.description ?? props.subject?.product?.name}
              </strong>

              <strong style={{ width: '100%' }}>
                <pre className={styles.descriptionLines}>{labelString(props.subject)}</pre>
              </strong>
            </VBox>
          )}
          {!isProductSubject && <strong style={{ width: '100%', paddingTop: '20px' }}>{labelString(props.subject)}</strong>}

          <div style={{ display: 'flex', gap: '8px', paddingTop: '10px' }}>
            <div onClick={onClick} style={{ fontSize: '20px', color: 'lightgray', cursor: 'pointer' }}>
              <EditSquare />
            </div>
            <div onClick={onDelete} style={{ fontSize: '20px', color: 'red', cursor: 'pointer' }}>
              <TimesSquare />
            </div>
          </div>
        </HBox>

        {props.subject?.type == INVOICE_SUBJECT_TYPES.VEHICLE ? (
          <VBox style={{ width: '100%', marginBottom: '20px', whiteSpace: 'nowrap' }}>
            {props.subject.btwOrMarge == BtwOrMarge.MARGE && (
              <>
                <HBox>
                  <span>{lbl('invoice.subject.financial_price_marge_excl_bpm')}</span>
                  <span>{formatCurrency(props?.subject?.financial_price_marge_excl_bpm)}</span>
                </HBox>

                <HBox>
                  <span>{lbl('invoice.subject.financial_price_marge_incl_bpm')}</span>
                  <span>{formatCurrency(props?.subject?.financial_price_marge_incl_bpm)}</span>
                </HBox>
              </>
            )}
            {props.subject.btwOrMarge == BtwOrMarge.BTW && (
              <HBox>
                <span>{lbl('invoice.subject.financial_price_excl_vat_excl_bpm')}</span>
                <span>{formatCurrency(props?.subject?.financial_price_excl_vat_excl_bpm)}</span>
              </HBox>
            )}
            <HBox>
              <span>{lbl('vehicle.property.outgoing_rest_bpm')}</span>
              <HBox right>
                <span>{formatCurrency(props?.subject?.outgoing_rest_bpm)}</span>
                {props.subject?.vehicle?.taxiVerleden && (
                  <OnMouseOverNotification message={props.lbl('alert.is_taxi_tax_message')} />
                )}
              </HBox>
            </HBox>
            <HBox>
              <span>{lbl('invoice.details.vat_amount')}</span>
              <span>{formatCurrency(props?.subject?.subjectVat?.amount)}</span>
            </HBox>
            <HBox>
              <span>{lbl('vehicle.order.total_price')}</span>
              <span>{formatCurrency(props?.subject?.price)}</span>
            </HBox>
          </VBox>
        ) : props.subject.type === INVOICE_SUBJECT_TYPES.PRODUCT ? (
          <VBox style={{ width: '100%', marginBottom: '20px', whiteSpace: 'nowrap' }}>
            <HBox>
              <span>{lbl('invoice.subject.price_excl_vat')}</span>
              <span>{formatCurrency(props?.subject?.product_price_excl_vat)}</span>
            </HBox>
            <HBox>
              <span>{lbl('invoice.subject.price_incl_vat')}</span>
              <span>{formatCurrency(props?.subject?.product_price_incl_vat)}</span>
            </HBox>
          </VBox>
        ) : (
          <VBox style={{ width: '100%', marginBottom: '20px', whiteSpace: 'nowrap' }}>
            <HBox>
              <span>{lbl('invoice.subject.price_excl_vat')}</span>
              <span>{formatCurrency(props?.subject?.cost_price_excl_vat)}</span>
            </HBox>
            <HBox>
              <span>{lbl('invoice.subject.price_incl_vat')}</span>
              <span>{formatCurrency(props?.subject?.cost_price_incl_vat)}</span>
            </HBox>
          </VBox>
        )}
      </Row>
    );
  };

  if (props.direction == 'incoming') {
    return renderIncomingSubjectItem();
  }

  if (props.outgoingDesignV2) {
    return renderSubjectV2design();
  }
  return (
    <Row key={props.subject.id}>
      <Cell onClick={onClick}>{lbl(`${labelString(props.subject)}`)}</Cell>
      <Cell>
        <Button onClick={onDelete}>
          <Times />
        </Button>
      </Cell>
    </Row>
  );
}
